;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { z } from "zod/v4";
import { emailSignInSchema } from "@/lib/schema/auth";
import { UserRole } from "@/types/user";

export const teamMemberSchema = emailSignInSchema.extend({
	role: z.enum(UserRole),
});

export const teamMemberPermissionUnitSchema = z.object({
	create: z.boolean(),
	delete: z.boolean(),
	edit: z.boolean(),
	view: z.boolean(),
});

export const teamMemberWithPermissionsSchema = z.object({
	permissions: z.record(z.string(), teamMemberPermissionUnitSchema),
});

export const completeTeamMemberSchema = teamMemberSchema.extend(
	teamMemberWithPermissionsSchema.shape,
);

export const multipleCompleteTeamMemberSchema = z.array(
	completeTeamMemberSchema.passthrough(),
);
